"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _utils.wrapValidator)(function (propType, condition) {
  return function (props, propName, componentName) {
    if (!(0, _isFunction.default)(propType)) {
      return new Error("Invalid PropType validator function supplied to \"".concat(componentName, "\" for prop \"").concat(propName, "\". Validation failed."));
    }

    if (!(0, _isFunction.default)(condition)) {
      return new Error("Invalid condition function supplied to \"".concat(componentName, "\" for prop \"").concat(propName, "\". Validation failed."));
    }

    if (condition(props)) {
      return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`. Forbidden condition returned true. Prop is forbidden."));
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };
});

exports.default = _default;